import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=e3c65890&scoped=true&"
import script from "./ProductsPage.vue?vue&type=script&lang=js&"
export * from "./ProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsPage.vue?vue&type=style&index=0&id=e3c65890&lang=stylus&scoped=true&"
import style1 from "./ProductsPage.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c65890",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IntSlides: require('/var/www/fs-store/components/IntSlides.vue').default,ProductsCard: require('/var/www/fs-store/components/ProductsCard.vue').default,ModalProducts: require('/var/www/fs-store/components/ModalProducts.vue').default})
